module.exports = __webpack_public_path__ + "static/img/6石拓.eae5091.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/6石拓.jpg
// module id = BjoZ
// module chunks = 0